import { render, staticRenderFns } from "./default.vue?vue&type=template&id=fe55529c&"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports